<script>
import {
  filtersComputed,
  filtersMethods,
  edgeComputed,
  edgeMethods,
} from '@state/helpers'

export default {
  data: function() {
    return {
      url: 'http://edge.thing.events/' + window.location.host + '/',
    }
  },
  computed: {
    ...filtersComputed,
    ...edgeComputed,
  },

  methods: {
    ...filtersMethods,
    ...edgeMethods,
  },
}
</script>

<template>
  <div class="">
    <b-card-body
      class="animated fadeIn card info-card card-body device-card-body-info mb-3 p-0 pb-3 clearfix"
    >
      <b-row class="ml-0 mr-0 device-info-row">
        <b-col class="h5 pl-3  text-uppercase mb-0 text-uppercase pt-1">
          Edge Core
          <span class="w-100 font-weight-bold  text-lowercase btn-block text-muted">
            {{ url }}
          </span>
        </b-col>
      </b-row>
    </b-card-body>

    <b-card-body class="animated fadeIn  info-card p-0 clearfix">
      <span class="w-100 pl-3 mb-2 font-weight-bold  btn-block text-muted">
        EDGE LOCATION
      </span>
    </b-card-body>

    <b-card-body
      class="animated fadeIn card info-card card-body device-card-body-info pt-2 p-0 pb-2 clearfix edge-menu"
    >
      <b-row class="ml-0 mr-0 device-info-row">
        <b-col class="h5 text-uppercase">
          MC1
          <span class="w-100 font-weight-bold text-lowercase  btn-block text-muted">
            http://10.0.11.209/
          </span>
        </b-col>
      </b-row>
    </b-card-body>

    <b-card-body
      class="animated fadeIn card info-card card-body device-card-body-info pt-2 p-0 pb-2 clearfix edge-menu"
    >
      <b-row class="ml-0 mr-0 device-info-row">
        <b-col class="h5 text-uppercase ">
          MILL
          <span class="font-weight-bold text-lowercase  btn-block text-muted">
            {{ url }}
          </span>
        </b-col>
      </b-row>
    </b-card-body>
  </div>
</template>

<style lang="scss">
.filter {
  padding: 1rem;
  border-bottom: 1px solid #23282c;
  margin-bottom: 0 !important;
}
.edge-menu {
  margin-bottom: 0 !important;
  border: none;
  cursor: pointer;
}
.edge-menu:hover {
  background: #321fdb !important;
}
</style>
